export default {"src":"/_next/static/media/google.f54accfa.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};